import { createAsyncThunk } from '@reduxjs/toolkit';
import { logger } from 'common/services';
import { RootState } from 'store';
import { selectActiveAudioOutputDevice } from 'user/state';

export const playSound = createAsyncThunk<void, { soundSrc: string; deviceId?: string }>(
  'app/playSound',
  async ({ soundSrc, deviceId: deviceIdOverride }, { getState }) => {
    try {
      const activeAudioOutputDevice = selectActiveAudioOutputDevice(getState() as RootState);
      const deviceId = deviceIdOverride ?? activeAudioOutputDevice?.deviceId;
      const soundSample = new Audio(soundSrc);
      soundSample.volume = 0.3;
      if (deviceId && typeof soundSample?.setSinkId === 'function') {
        await soundSample.setSinkId(deviceId);
      }
      soundSample.play();
    } catch (e) {
      logger.error(e);
    }
  }
);
